import { Stack } from '@mui/material';
import moment from 'moment';
import { Fragment, useState } from 'react';
import { AuditLogReportRequest, FilterCriteria, User } from '../../../model/auditlogreports';
import AuditLogReportFactory from './AuditLogReportFactory';
import ReportCriteriaSelection from './ReportCriteriaSelection';
import { string } from 'yargs';

const AuditLogReportsContainer = () => {
    const [reportType, setReportType] = useState<string>('');
    const [filterBy, setFilterBy] = useState<string>('');
    const [customStartDate, setCustomStartDate] = useState<string>('');
    const [customEndDate, setCustomEndDate] = useState<string>('');
    const [selectedUsers, setSelectedUsers] = useState<User[]>([]);
    const [submitReport, setSubmitReport] = useState<boolean>(false);

    const isReportCriteriaValid = () => {
        if(reportType == '' || filterBy == '' || selectedUsers.length == 0) return true;
        if(filterBy == 'customDates' && (customStartDate == '' || customEndDate == '')) return true;

        return false;
    }
    const onSubmitReport = () => {
        setSubmitReport(true);
    }
    const handleFilterByChange = (newFilter: string) => {
        if(filterBy !== 'customDates') {
            setCustomStartDate('');
            setCustomEndDate('');
        }
        setFilterBy(newFilter);
    }
    const createAuditLogReportRequest = () => {
        const request: AuditLogReportRequest = {
            userIds: [],
            startDate: '',
            endDate: ''
        };

        if(filterBy == 'customDates') {
            request.startDate = customStartDate;
            request.endDate = customEndDate;
        } else {
            const startEndDates = getDates(filterBy);
            request.startDate = startEndDates?.startDate;
            request.endDate = startEndDates?.endDate;
        }        

        for (const user of selectedUsers) {
            if(user.id == 'allUsers') {
                request.userIds = [];
                break;
            }
            request.userIds.push(user.id)
        }

        return request;
    }
    const getDates = (key: string): { startDate: string; endDate: string } => {
        const ed: string = moment().format('YYYY-MM-DDTHH:mm:ss.SSS');
        switch (key) {
            case 'last7Days':
                return { startDate: moment().subtract(7, 'days').format('YYYY-MM-DDTHH:mm:ss.SSS'), endDate: ed };
            case 'last14Days':
                return {startDate: moment().subtract(14, 'days').format('YYYY-MM-DDTHH:mm:ss.SSS'), endDate: ed};
            case 'last30Days':
                return {startDate: moment().subtract(30, 'days').format('YYYY-MM-DDTHH:mm:ss.SSS'), endDate: ed};
            case 'monthToDate':
                return {startDate: moment().startOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS'), endDate: ed};
            case 'last90Days':
                return {startDate: moment().subtract(90, 'days').format('YYYY-MM-DDTHH:mm:ss.SSS'), endDate: ed};
            case 'quarterToDate':
                return {startDate: moment().startOf('quarter').format('YYYY-MM-DDTHH:mm:ss.SSS'), endDate: ed};
            case 'yearToDate':
                return { startDate: moment().startOf('year').format('YYYY-MM-DDTHH:mm:ss.SSS'), endDate: ed };
            default:
                return { startDate: moment().subtract(7, 'days').format('YYYY-MM-DDTHH:mm:ss:SSS'), endDate: ed };
        }
    }

    const Component = AuditLogReportFactory(reportType);

    return (
        <Fragment>
            <Stack sx={{
                alignItems: 'center',
                // background: 'repeating-linear-gradient(45deg, black, transparent 100px)'
            }}>
                <Stack
                    sx={{
                        fontFamily: 'Montserrat, Roboto, "Helvetica Neue", Arial, sans-serif',
                        fontSize: '1rem',
                        lineHeight: '1.334',
                        color: 'rgb(29, 99, 159)',
                        fontWeight: '600',
                        textTransform: 'uppercase',
                        marginBottom: '0.5rem'
                    }}>
                    Select Report Criteria :
                </Stack>
                <Stack direction='row' spacing={2}>
                    <ReportCriteriaSelection setReportType={setReportType} setFilterBy={handleFilterByChange} setCustomStartDate={setCustomStartDate} setCustomEndDate={setCustomEndDate}
                        setSelectedUsers={setSelectedUsers} canEnableSubmit={isReportCriteriaValid()} onSubmitReport={onSubmitReport} />
                </Stack>
            </Stack>
            {submitReport && Component && <Stack sx={{
                border: '1px solid rgba(2,117,216)',
                borderRadius: '25px',
                alignItems: 'center',
                marginTop: '2rem'
            }}>
                <Component request={createAuditLogReportRequest()} reportType = {reportType} filterBy = {filterBy} users = {selectedUsers}/>
            </Stack>}
        </Fragment>
    );
};

export default AuditLogReportsContainer;